import { httpClient } from "../../../shared/api";

export const projectsApi = {
  listCustomers:    ()            => httpClient.get("/customers"),
  createCustomer:   (payload)     => httpClient.post("/customers", payload),
  updateCustomer:   (id, payload) => httpClient.put(`/customers/${id}`, payload),

  listProjects:     ()            => httpClient.get("/projects"),
  createProject:    (payload)     => httpClient.post("/projects", payload),
  updateProject:    (id, payload) => httpClient.put(`/projects/${id}`, payload),

  listUsers:        ()            => httpClient.get("/users/dropdown"),
  featuresWithSubs: ()            => httpClient.get("/features/all-with-subs"),
  bulkCreateTasks:  (payload)     => httpClient.post("/tasks/bulk", payload),

  listProducts:            ()                     => httpClient.get("/products"),
  listCustomerProducts:    (customerId)            => httpClient.get(`/customers/${customerId}/products`),
  addCustomerProduct:      (customerId, productId) => httpClient.post(`/customers/${customerId}/products`, { product_id: productId }),
  removeCustomerProduct:   (customerId, productId) => httpClient.delete(`/customers/${customerId}/products/${productId}`),
};
